import { useEffect, useState } from 'react';

import { formDataInstance } from '@/common/axios';
import CONFIG from '@/config';

export type StoreStaff = {
  id: number;
  firstName: string;
  lastName: string;
  fullName?: string;
  actorType?: string;
};

export type StoreStaffeInfo = {
  items: StoreStaff[];
  loading: boolean;
};

export interface StoreStaffResponse {
  data: {
    data: {
      id: number;
      firstName: string;
      lastName: string;
    }[];
  };
}

export const url = `${CONFIG.USERS_API_URL}/staff/active-staff`;

export const addFullName = (data: StoreStaff[]): StoreStaff[] =>
  data.map(s => ({
    ...s,
    fullName: `${s.firstName} ${s.lastName}`,
    actorType: 'STAFF'
  }));

export const useActiveStoreStaff = (): StoreStaffeInfo => {
  const [loading, setLoading] = useState<boolean>(false);
  const [staff, setStaff] = useState<StoreStaff[]>([]);

  useEffect(() => {
    setLoading(true);
    formDataInstance
      .get(url)
      .then((response: StoreStaffResponse) => {
        const staff = addFullName(response.data.data);
        setStaff(staff);
        return staff;
      })
      .catch(e => {
        console.log(e);
        return e;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    items: staff,
    loading
  };
};
